import { PermissionsList } from '@modules/permissions/constants';
import { Permission } from '@modules/permissions/utils';

export const ADMIN_REPORTS_ROUTE_NAME = Symbol('admin-reports');
export const ADMIN_SUBAFFILIATE_REPORTS_ROUTE_NAME = Symbol('admin-subaffiliate-reports');
export const ADMIN_CREATIVE_REPORTS_ROUTE_NAME = Symbol('admin-creative-reports');

export const ADMIN_REPORTS_PLAYER_PROFILE = Symbol('admin-reports.player-profile');
export const ADMIN_REPORTS_PLAYER_PROFILE_TRACKER_TAB = Symbol('admin-reports.player-profile.tracker-tab');
export const ADMIN_REPORTS_PLAYER_PROFILE_MAIN_DATA_TAB = Symbol('admin-reports.player-profile.main-data-tab');
export const ADMIN_REPORTS_PLAYER_PROFILE_ACTIVITY_TAB = Symbol('admin-reports.player-profile.activity-tab');
export const ADMIN_REPORTS_PLAYER_PROFILE_TRACKING_HISTORY_EDIT_ROUTE_NAME = Symbol('admin-reports.player-profile.tracker-tab.tracker-history-edit');

export const AFFILIATE_REPORTS_ROUTE_NAME = Symbol('affiliate-reports');
export const AFFILIATE_SUBAFFILIATE_REPORTS_ROUTE_NAME = Symbol('affiliate-subaffiliate-reports');
export const AFFILIATE_CREATIVE_REPORTS_ROUTE_NAME = Symbol('affiliate-creative-reports');

export const TRANSLATION_GROUP_REPORTS = Symbol('reports-translations');
export const TRANSLATION_GROUP_SUBAFFILIATE_REPORTS = Symbol('subaffiliate-reports-translations');
export const TRANSLATION_GROUP_CREATIVE_REPORTS = Symbol('creative-reports-translations');

export const REPORT_OPTIONS_API_URL = ':namespace/:reportType/options';
export const REPORT_OPTIONS_QUERY = 'report.options';

export const REPORT_TABS_API_URL = ':namespace/:reportType/:widgetType/list';
export const REPORT_TABS_QUERY = 'report.tabs';

export const REPORT_ADD_TAB_API_URL = ':namespace/:reportType/:widgetType';
export const REPORT_ADD_TAB_MUTATION = 'report.add-tab';

export const REPORT_REMOVE_TAB_API_URL = ':namespace/:reportType/:widgetType/:tabId';
export const REPORT_REMOVE_TAB_MUTATION = 'report.remove-tab';

export const REPORT_INNER_TAB_API_URL = ':namespace/:reportType/:widgetType/:tabId/tabs/:innerTabId';
export const REPORT_INNER_TAB_QUERY = 'report.inner-tab';

export const REPORT_CHANGE_INNER_TAB_MUTATION = 'report.change-inner-tab';
export const REPORT_ADD_INNER_TAB_API_URL = ':namespace/:reportType/:widgetType/:tabId/tabs/:innerTabId/add';
export const REPORT_REMOVE_INNER_TAB_API_URL = ':namespace/:reportType/:widgetType/:tabId/tabs/:innerTabId/remove';

export const REPORT_CHANGE_TAB_NAME_API_URL = ':namespace/:reportType/:widgetType/:tabId';
export const REPORT_CHANGE_TAB_NAME_MUTATION = 'report.change-tab-name';

export const REPORT_CHANGE_STRUCTURE_STATE_API_URL = ':namespace/:reportType/structures/:tabId';
export const REPORT_CHANGE_STRUCTURE_STATE_MUTATION = 'report.change-structure-state';

export const REPORT_STRUCTURE_STATES_API_URL = ':namespace/:reportType/stucture_states';
export const REPORT_STRUCTURE_STATES_QUERY = 'report.structure-states';

export const REPORT_GENERATE_QUERY = 'report.generate';
export const REPORT_GENERATE_API_URL = ':namespace/:reportType/generate_report';

export const REPORT_DOWNLOAD_MUTATION = 'report.download';
export const REPORT_DOWNLOAD_API_URL = ':namespace/:reportType/download_report';

export const REPORT_UPLOAD_FILE_MUTATION = 'report.upload-file';
export const REPORT_UPLOAD_FILE_API_URL = ':namespace/:reportType/:widgetType/:tabId/tabs/:innerTabId/load_file_with_players';

export const REPORTS_PERMISSIONS = {
  REPORTS_GENERATE_REPORT: new Permission(
    PermissionsList.admin.REPORTS_GENERATE_REPORT,
    PermissionsList.affiliate.REPORTS_GENERATE_REPORT,
  ),
  REPORTS_DOWNLOAD_REPORT: new Permission(
    PermissionsList.admin.REPORTS_DOWNLOAD_REPORT,
    PermissionsList.affiliate.REPORTS_DOWNLOAD_REPORT,
  ),
  REPORTS_STUCTURE_STATES: new Permission(
    PermissionsList.admin.REPORTS_STUCTURE_STATES,
    PermissionsList.affiliate.REPORTS_STUCTURE_STATES,
  ),

  SUBAFFILIATE_REPORTS_GENERATE_REPORT: new Permission(
    PermissionsList.admin.SUBAFFILIATEREPORTS_GENERATE_REPORT,
    PermissionsList.affiliate.SUBAFFILIATEREPORTS_GENERATE_REPORT,
  ),
  SUBAFFILIATE_REPORTS_DOWNLOAD_REPORT: new Permission(
    PermissionsList.admin.SUBAFFILIATEREPORTS_DOWNLOAD_REPORT,
    PermissionsList.affiliate.SUBAFFILIATEREPORTS_DOWNLOAD_REPORT,
  ),

  CREATIVE_REPORTS_GENERATE_REPORT: new Permission(
    PermissionsList.admin.CREATIVEREPORTS_GENERATE_REPORT,
    PermissionsList.affiliate.CREATIVEREPORTS_GENERATE_REPORT,
  ),
  CREATIVE_REPORTS_DOWNLOAD_REPORT: new Permission(
    PermissionsList.admin.CREATIVEREPORTS_DOWNLOAD_REPORT,
    PermissionsList.affiliate.CREATIVEREPORTS_DOWNLOAD_REPORT,
  ),
};
